import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox as CHCheckbox } from '@chakra-ui/react'

CustomCheckbox.propTypes = {
  props: PropTypes.any,
}

function CustomCheckbox(props) {
  return (
    <CHCheckbox
      colorScheme="facebook"
      size="lg"
      bg="white"
      mt={'2px'}
      ml={'8px'}
      layerStyle="checkbox"
      _before={{
        '& > control': {
          content: '""',
          position: 'absolute',
          backgroundColor: 'transparent',
          bottom: 1,
          left: 0,
          width: '16px',
          height: '16px',
          boxShadow: '0 0 15px rgba(0, 0, 0, .3)',
        },
      }}
      _checked={{ layerStyle: 'checkboxChecked' }}
      {...props}
    />
  )
}

CustomCheckbox.displayName = 'CustomCheckbox'

export default React.memo(props => <CustomCheckbox {...props} />)
